<!--
 * A Vue component for showing an info icon, which shows additional information as a tooltip
 *
 *
 * Properties
 * ==========
 * - name -
 * (Optional) The text that is used as id and name for icon element.
 *
 * - title -
 *  The text that is shown when hovering over the info icon.
 *
 * Usage
 * ==========
 * - Set the title property for the info-text.
 * - You can add extra attributes from the parent component
-->
<template>
    <span>
        <img
            :id="name"
            :name="name"
            :title="title"
            :alt="title"
            class="info"
            src="~@/assets/imported-icons/ic_fluent_info_20_regular.svg"
        />
    </span>
</template>

<script>
    export default {
        inheritAttrs: false,
        name: 'InfoButton',
        props: {
            title: { type: String, required: false, default: '' },
            name: { type: String, required: false, default: 'bv-info-btn' }
        }
    };
</script>

<style scoped lang="scss">
.info {
    height: 20px;

    &:hover {
        cursor: pointer;
    }
}
</style>
